import { supabase } from '../lib/supabase';

export const billingService = {
  /**
   * Fetch the authenticated user's Stripe invoice history.
   * Returns an array of { id, number, date, amount, currency, status, invoicePdf, hostedInvoiceUrl }.
   * Throws on failure so callers can surface an error state.
   */
  async getMyInvoices() {
    const { data, error } = await supabase?.functions?.invoke('list-my-invoices', {
      body: {},
    });

    if (error) {
      // FunctionsHttpError carries the raw Response in error.context —
      // parse it so callers see the server's message.
      if (error?.context?.json) {
        try {
          const body = await error.context.json();
          throw new Error(body?.details || body?.error || error.message);
        } catch (parseErr) {
          if (parseErr instanceof Error && parseErr !== error) throw parseErr;
        }
      }
      throw error;
    }

    return data?.invoices || [];
  },
};
